/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import { Checkbox, Grid, makeStyles, Typography } from '@material-ui/core';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';
import {
  fullUpdateLicenseGroupClientsRequest,
  createLicenseGroupRequest,
} from 'modules/environments/actions';
import { getAllClientsRequest } from 'modules/clients/actions';
import { modalClose } from 'modules/modal/actions';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { useParams } from 'react-router';
import { Query, useTableFilters } from 'hooks/useTableFilters';
import { SearchBar } from 'components/SearchBar';
import { ClientFields, ListClientDataProps } from 'modules/clients/interfaces';
import Button from 'components/Button';
import { LicenseGroupsFields } from 'modules/environments/interfaces';
import { useCheckboxes } from 'hooks';
import { Alert } from '@material-ui/lab';
import styles from './styles';

const useStyles = makeStyles(styles);

interface Props {
  clientList: ListClientDataProps;
  initialValues: LicenseGroupsFields;
  isLoading: boolean;
  queryGroups: Query;
  getAllClientsRequest: (props) => void;
  fullUpdateLicenseGroupClientsRequest: (props) => void;
  modalClose: () => void;
}

const EditClients = ({
  clientList,
  initialValues,
  isLoading,
  queryGroups,
  getAllClientsRequest,
  fullUpdateLicenseGroupClientsRequest,
  modalClose,
}: Props) => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();

  const {
    query,
    searchValue,
    itemOrder,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters();

  const {
    checks,
    handleCheck,
    setChecks,
    handleAllCheck,
    isChecked,
  } = useCheckboxes<ClientFields, string>({
    items: clientList?.results,
    isItemChecked: (item, check) => item?.client_uuid === check,
    createCheckItem: item => item?.client_uuid,
  });
  const isAllChecked =
    !!clientList?.results?.length &&
    clientList.results.every(item => isChecked(item?.client_uuid));

  React.useEffect(() => {
    if (initialValues?.clients) {
      const initialClientIds = initialValues?.clients?.map(
        client => client?.uuid
      );
      setChecks(initialClientIds);
    }
  }, [initialValues?.clients]);

  const headers = [
    {
      key: 'name',
      i18n: 'NAME_KEY',
      order: true,
    },
    {
      key: 'client_uuid',
      i18n: 'ID',
      order: true,
    },
    {
      key: 'client_uuid',
      i18n: 'LICENSE_GROUP_KEY',
      order: true,
    },
  ];

  React.useEffect(() => {
    getAllClientsRequest({
      ...query,
      environment_uuid: id,
    });
  }, [query, getAllClientsRequest, id]);

  const handleEditClients = () => {
    fullUpdateLicenseGroupClientsRequest({
      environmentUuid: id,
      licenseGroupUuid: initialValues?.uuid,
      cli_uuids: checks,
      query: queryGroups,
    });
    modalClose();
  };
  const selectedClientFromOtherGroup = React.useMemo(() => {
    return checks.some(check =>
      clientList?.results?.find(
        item =>
          item?.client_uuid === check &&
          item?.licenses?.license_group?.name &&
          item?.licenses?.license_group?.uuid !== initialValues?.uuid
      )
    );
  }, [checks, clientList?.results, initialValues?.uuid]);

  return (
    <>
      <Grid container>
        <Typography>{i18n.t('EDIT_CLIENTS_DESCRIPTION_KEY')}</Typography>
      </Grid>
      <Grid container alignItems="center" className={classes.actionsHeader}>
        <Grid container>
          <SearchBar
            id="search-clients"
            isLoading={isLoading}
            searchValue={searchValue}
            handleSearch={handleSearch}
            setSearchValue={setSearchValue}
          />
        </Grid>
      </Grid>
      <Grid>
        <TableItems
          header={
            <>
              <TableCell className={classes.checkboxCell}>
                <Checkbox
                  checked={isAllChecked}
                  onClick={() => handleAllCheck(isAllChecked)}
                  id="select-all-clients"
                  size="small"
                />
              </TableCell>
              {headers.map(item => (
                <TableCell
                  key={item?.key}
                  order={item?.order}
                  handleOrder={() =>
                    item?.order ? handleOrder(item?.key) : null
                  }
                  markOderItem={itemOrder === item?.key}
                >
                  {i18n.t(item?.i18n)}
                </TableCell>
              ))}
            </>
          }
          renderItems={(item: ClientFields) => (
            <TableRow key={item?.client_uuid}>
              <TableCell textAlignCenter className={classes.checkboxCell}>
                <Checkbox
                  checked={isChecked(item?.client_uuid)}
                  onChange={() => handleCheck(item?.client_uuid)}
                  size="small"
                />
              </TableCell>
              <TableCell className={classes.rowAllRowsClient}>
                {item?.name}
              </TableCell>
              <TableCell className={classes.rowAllRowsCountClient}>
                {item?.client_uuid}
              </TableCell>
              <TableCell className={classes.rowAllRowsCountClient}>
                {item?.licenses?.license_group?.name}
              </TableCell>
            </TableRow>
          )}
          data={clientList}
          isLoading={isLoading}
          onChangePage={handlePageChange}
          onChangeLimit={handleLimitChange}
          notFoundText={i18n.t('NO_CLIENT_KEY')}
        />
      </Grid>
      {selectedClientFromOtherGroup && (
        <Alert className={classes.alert} severity="warning" color="info">
          <Grid item>
            <Typography className={classes.alertText}>
              {i18n.t('CLIENT_ALREADY_IN_LICENSE_GROUP_KEY')}
            </Typography>
          </Grid>
        </Alert>
      )}
      <Grid container justify="flex-end" className={classes.buttons}>
        <Button
          id="edit-clients-group"
          submitButton
          onClick={() => handleEditClients()}
        >
          {i18n.t('CONFIRM_KEY')}
        </Button>
        <Button id="cancel-button" variant="outlined" onClick={modalClose}>
          {i18n.t('CANCEL_KEY')}
        </Button>
      </Grid>
    </>
  );
};

const mapStateToProps = ({
  clients: { isLoading, clientList },
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
  clientList,
  isLoading,
});

export default connect(mapStateToProps, {
  getAllClientsRequest,
  createLicenseGroupRequest,
  fullUpdateLicenseGroupClientsRequest,
  modalClose,
})(EditClients);
